<template>
    <Layout sub="overview">
        <section class="flex flex-col">
            <!-- Header -->
            <div class="flex flex-row w-full justify-between items-center">
                <div class="flex flex-col w-1/2">
                    <h1
                        class="w-full text-semibold text-[24px] hover:border-0 focus:ring-0 focus:border-0 border-0 bg-transparent"
                    >
                        Reports Overview
                    </h1>
                </div>
                <div class="flex flex-row w-[275px] space-x-[12px]">
                    <Datepicker
                        class="w-full"
                        :maxDate="new Date()"
                        :minDate="new Date('2021-05-30')"
                        @update:modelValue="handleChange"
                        inputClassName="dp-custom-input"
                        v-model="selectedDate"
                        range
                        :enableTimePicker="false"
                    >
                    </Datepicker>
                </div>
            </div>

            <div
                class="flex items-center justify-center w-full bg-white px-[20px] py-[40px] space-y-[20px] mt-[20px] rounded-lg border-[2px] border-[#f3f3f3]"
                v-if="isLoading"
            >
                <Loading />
            </div>

            <div v-else>
                <!-- Overview -->
                <div
                    class="flex flex-col w-full bg-white px-[20px] py-[20px] space-y-[20px] mt-[20px] rounded-lg border-[2px] border-[#f3f3f3]"
                >
                    <h2 class="text-[18px] font-semibold text-black">
                        Applicants Overview
                    </h2>
                    <div class="flex flex-row w-full space-x-[50px]">
                        <!-- Left -->
                        <div class="flex flex-col w-2/3 space-y-[30px]">
                            <!-- Header -->
                            <div
                                class="flex flex-row justify-between space-x-[20px]"
                            >
                                <div
                                    class="flex flex-row items-center space-x-[10px]"
                                >
                                    <span
                                        class="text-[18px] font-semibold text-black"
                                        >{{
                                            items?.applicants.count.value ?? 0
                                        }}
                                        <i class="font-normal text-sm"
                                            >Application Received</i
                                        ></span
                                    >
                                    <span
                                        :class="
                                            items.applicants.count.trend
                                                .symbol === 'up'
                                                ? 'text-green-500'
                                                : 'text-face-red'
                                        "
                                        class="hidden inline-flex text-[12px] space-x-[6px]"
                                    >
                                        <i>
                                            <svg
                                                v-if="
                                                    items.applicants.count.trend
                                                        .symbol === 'up'
                                                "
                                                class="w-[14px] h-[14px] fill-current"
                                                viewBox="0 0 14.37 14.37"
                                            >
                                                <g
                                                    transform="translate(-172 -444)"
                                                >
                                                    <g
                                                        transform="translate(172 444)"
                                                    >
                                                        <path
                                                            id="Vector"
                                                            d="M8.233,12.873H4.64C1.389,12.873,0,11.484,0,8.233V4.64C0,1.389,1.389,0,4.64,0H8.233c3.251,0,4.64,1.389,4.64,4.64V8.233C12.873,11.484,11.484,12.873,8.233,12.873ZM4.64.9C1.88.9.9,1.88.9,4.64V8.233c0,2.76.982,3.742,3.742,3.742H8.233c2.76,0,3.742-.982,3.742-3.742V4.64C11.975,1.88,10.993.9,8.233.9Z"
                                                            transform="translate(0.748 0.748)"
                                                        />
                                                        <path
                                                            id="Vector-2"
                                                            data-name="Vector"
                                                            d="M2.988,3.437a.452.452,0,0,1-.449-.449V.9H.449A.452.452,0,0,1,0,.449.452.452,0,0,1,.449,0H2.988a.452.452,0,0,1,.449.449V2.988A.452.452,0,0,1,2.988,3.437Z"
                                                            transform="translate(5.892 4.155)"
                                                        />
                                                        <path
                                                            id="Vector-3"
                                                            data-name="Vector"
                                                            d="M.448,4.286A.444.444,0,0,1,.13,4.154a.452.452,0,0,1,0-.635L3.519.13a.449.449,0,0,1,.635.635L.765,4.154A.434.434,0,0,1,.448,4.286Z"
                                                            transform="translate(5.043 4.151)"
                                                        />
                                                        <path
                                                            id="Vector-4"
                                                            data-name="Vector"
                                                            d="M4.041,1.48A11.849,11.849,0,0,1,.3.876.451.451,0,0,1,.023.307.446.446,0,0,1,.592.025a10.977,10.977,0,0,0,6.9,0,.449.449,0,0,1,.287.85A11.745,11.745,0,0,1,4.041,1.48Z"
                                                            transform="translate(3.144 9.435)"
                                                        />
                                                        <path
                                                            id="Vector-5"
                                                            data-name="Vector"
                                                            d="M0,0H14.37V14.37H0Z"
                                                            fill="none"
                                                            opacity="0"
                                                        />
                                                    </g>
                                                </g>
                                            </svg>
                                            <svg
                                                v-else
                                                class="hidden w-[14px] h-[14px] fill-current"
                                                viewBox="0 0 14.37 14.37"
                                            >
                                                <g
                                                    transform="translate(-172 -444)"
                                                >
                                                    <g
                                                        transform="translate(172 444)"
                                                    >
                                                        <path
                                                            id="Vector"
                                                            d="M8.233,12.873H4.64C1.389,12.873,0,11.484,0,8.233V4.64C0,1.389,1.389,0,4.64,0H8.233c3.251,0,4.64,1.389,4.64,4.64V8.233C12.873,11.484,11.484,12.873,8.233,12.873ZM4.64.9C1.88.9.9,1.88.9,4.64V8.233c0,2.76.982,3.742,3.742,3.742H8.233c2.76,0,3.742-.982,3.742-3.742V4.64C11.975,1.88,10.993.9,8.233.9Z"
                                                            transform="translate(0.748 0.748)"
                                                        />
                                                        <path
                                                            id="Vector-2"
                                                            data-name="Vector"
                                                            d="M2.988,3.437a.452.452,0,0,1-.449-.449V.9H.449A.452.452,0,0,1,0,.449.452.452,0,0,1,.449,0H2.988a.452.452,0,0,1,.449.449V2.988A.452.452,0,0,1,2.988,3.437Z"
                                                            transform="translate(8.917 4.49) rotate(75)"
                                                        />
                                                        <path
                                                            id="Vector-3"
                                                            data-name="Vector"
                                                            d="M.448,4.286A.444.444,0,0,1,.13,4.154a.452.452,0,0,1,0-.635L3.519.13a.449.449,0,0,1,.635.635L.765,4.154A.434.434,0,0,1,.448,4.286Z"
                                                            transform="translate(8.702 3.67) rotate(75)"
                                                        />
                                                        <path
                                                            id="Vector-4"
                                                            data-name="Vector"
                                                            d="M4.041,1.48A11.849,11.849,0,0,1,.3.876.451.451,0,0,1,.023.307.446.446,0,0,1,.592.025a10.977,10.977,0,0,0,6.9,0,.449.449,0,0,1,.287.85A11.745,11.745,0,0,1,4.041,1.48Z"
                                                            transform="translate(3.144 9.435)"
                                                        />
                                                        <path
                                                            id="Vector-5"
                                                            data-name="Vector"
                                                            d="M0,0H14.37V14.37H0Z"
                                                            fill="none"
                                                            opacity="0"
                                                        />
                                                    </g>
                                                </g>
                                            </svg>
                                        </i>
                                        <i>{{
                                            items?.applicants?.count.trend.value
                                        }}</i>
                                    </span>
                                    <span
                                        class="hidden text-[12px] text-[#120F20]"
                                        >than previous week</span
                                    >
                                </div>
                                <div
                                    class="flex flex-row space-x-[6px] items-center"
                                >
                                    <span
                                        class="rounded-full inline-flex w-[8px] h-[8px] bg-turquoise"
                                    ></span>
                                    <span class="text-[#9CA3AF] text-[12px]"
                                        >Application Received</span
                                    >
                                </div>
                            </div>

                            <!-- Graph -->
                            <div class="w-full h-[400px]">
                                <BarChart
                                    :chartData="items?.applicants?.chart"
                                    :options="chartOptions"
                                />
                            </div>
                        </div>

                        <!-- Right -->
                        <div
                            class="flex flex-col w-1/3 font-medium text-[14px] text-black space-y-[40px]"
                        >
                            <div class="flex flex-col space-y-[30px]">
                                <div class="flex flex-row justify-between">
                                    <div
                                        class="flex flex-row space-x-[10px] items-center"
                                    >
                                        <span>
                                            <svg
                                                width="8.929"
                                                height="19.842"
                                                viewBox="0 0 8.929 19.842"
                                            >
                                                <path
                                                    id="Path_250"
                                                    data-name="Path 250"
                                                    d="M188.464,104.929a2.48,2.48,0,1,1,2.48-2.48.992.992,0,0,0,1.984,0,4.471,4.471,0,0,0-3.472-4.352v-1.1a.992.992,0,1,0-1.984,0v1.1a4.464,4.464,0,0,0,.992,8.816,2.48,2.48,0,1,1-2.48,2.48.992.992,0,1,0-1.984,0,4.471,4.471,0,0,0,3.472,4.352v1.1a.992.992,0,1,0,1.984,0v-1.1a4.464,4.464,0,0,0-.992-8.816Z"
                                                    transform="translate(-184 -96)"
                                                    fill="#ec1f28"
                                                />
                                            </svg>
                                        </span>
                                        <span>Total funds Requested</span>
                                    </div>
                                    <span class="font-semibold text-[14px]">{{
                                        items?.applicants.funds["requested"] ??
                                        "$0"
                                    }}</span>
                                </div>
                                <div class="hidden flex flex-row justify-between">
                                    <div
                                        class="flex flex-row space-x-[10px] items-center"
                                    >
                                        <span>
                                            <svg
                                                width="8.929"
                                                height="19.842"
                                                viewBox="0 0 8.929 19.842"
                                            >
                                                <path
                                                    id="Path_250"
                                                    data-name="Path 250"
                                                    d="M188.464,104.929a2.48,2.48,0,1,1,2.48-2.48.992.992,0,0,0,1.984,0,4.471,4.471,0,0,0-3.472-4.352v-1.1a.992.992,0,1,0-1.984,0v1.1a4.464,4.464,0,0,0,.992,8.816,2.48,2.48,0,1,1-2.48,2.48.992.992,0,1,0-1.984,0,4.471,4.471,0,0,0,3.472,4.352v1.1a.992.992,0,1,0,1.984,0v-1.1a4.464,4.464,0,0,0-.992-8.816Z"
                                                    transform="translate(-184 -96)"
                                                    fill="#7367f0"
                                                />
                                            </svg>
                                        </span>
                                        <span>Total funds approved</span>
                                    </div>
                                    <span class="font-semibold text-[14px]">{{
                                        items?.applicants.funds["approved"] ??
                                        "$0"
                                    }}</span>
                                </div>
                                <div class="flex flex-row justify-between">
                                    <div
                                        class="flex flex-row space-x-[10px] items-center"
                                    >
                                        <span>
                                            <svg
                                                width="8.929"
                                                height="19.842"
                                                viewBox="0 0 8.929 19.842"
                                            >
                                                <path
                                                    id="Path_250"
                                                    data-name="Path 250"
                                                    d="M188.464,104.929a2.48,2.48,0,1,1,2.48-2.48.992.992,0,0,0,1.984,0,4.471,4.471,0,0,0-3.472-4.352v-1.1a.992.992,0,1,0-1.984,0v1.1a4.464,4.464,0,0,0,.992,8.816,2.48,2.48,0,1,1-2.48,2.48.992.992,0,1,0-1.984,0,4.471,4.471,0,0,0,3.472,4.352v1.1a.992.992,0,1,0,1.984,0v-1.1a4.464,4.464,0,0,0-.992-8.816Z"
                                                    transform="translate(-184 -96)"
                                                    fill="#28c76f"
                                                />
                                            </svg>
                                        </span>
                                        <span>Total funds Disbursed</span>
                                    </div>
                                    <span class="font-semibold text-[14px]">{{
                                        items?.applicants.funds["disbursed"] ??
                                        "$0"
                                    }}</span>
                                </div>
                                <div
                                    class="relative bg-[#00d275] w-full h-[24px] bg-opacity-25"
                                >
                                    <span
                                        :style="{
                                            width: items?.applicants
                                                .loanGraphPercent
                                                ? `${items?.applicants.loanGraphPercent}%`
                                                : '0%',
                                        }"
                                        class="inline-block bg-[#00d275] h-full absolute"
                                    ></span>
                                </div>
                                <div
                                    class="flex flex-row space-x-[10px] justify-between"
                                >
                                    <div class="flex flex-row space-x-[10px] items-center">
                                        <span>
                                            <!--                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                aria-hidden="true"
                                                role="img"
                                                class="w-6 h-6"
                                                preserveAspectRatio="xMidYMid meet"
                                                viewBox="0 0 16 16"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M8.314.256a.75.75 0 1 0-1.128.988l.687.786A6.5 6.5 0 1 0 15 8.5v-.25a.75.75 0 1 0-1.5 0v.25a5 5 0 1 1-5.695-4.952l-.62.708a.75.75 0 1 0 1.13.988l1.75-2a.75.75 0 0 0 0-.988l-1.75-2Zm3.491 5.99a.75.75 0 0 1-.05 1.059l-2.75 2.5A.75.75 0 0 1 7.97 9.78L6.72 8.53a.75.75 0 0 1 1.06-1.06l.745.744l2.22-2.019a.75.75 0 0 1 1.06.05Z"
                                                ></path>
                                            </svg>-->
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                aria-hidden="true"
                                                role="img"
                                                class="w-6 h-6 text-green-500"
                                                preserveAspectRatio="xMidYMid meet"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M4 14v8h16v-8H4zm14 4H6v-2h12v2zM12 2C9.24 2 7 4.24 7 7l5 7l5-7c0-2.76-2.24-5-5-5z"
                                                ></path>
                                            </svg>
                                        </span>
                                        <span>Number of Disbursed Loans</span>
                                    </div>
                                    <span class="font-bold">{{
                                        items?.applicants.completed ?? 0
                                    }}</span>
                                </div>
                            </div><!--
                            <span
                                class="inline-flex w-full h-[2px] bg-gray-200"
                            ></span>
                            <div
                                class="flex flex-row space-x-[10px] justify-between"
                            >
                                <div class="flex flex-row space-x-[10px]">
                                    <span>
                                        <svg
                                            width="18.619"
                                            height="18.619"
                                            viewBox="0 0 18.619 18.619"
                                        >
                                            <path
                                                id="Vector"
                                                d="M10.667,16.679H4.461C1.629,16.679,0,15.05,0,12.218V4.461C0,1.629,1.629,0,4.461,0h6.206c2.832,0,4.461,1.629,4.461,4.461v7.758C15.128,15.05,13.5,16.679,10.667,16.679ZM4.461,1.164c-2.219,0-3.3,1.078-3.3,3.3v7.758c0,2.219,1.078,3.3,3.3,3.3h6.206c2.219,0,3.3-1.078,3.3-3.3V4.461c0-2.219-1.078-3.3-3.3-3.3Z"
                                                transform="translate(1.745 0.97)"
                                                fill="#ffab00"
                                            />
                                            <path
                                                id="Vector-2"
                                                data-name="Vector"
                                                d="M3.685,4.267H2.133A2.132,2.132,0,0,1,0,2.133V.582A.586.586,0,0,1,.582,0a.586.586,0,0,1,.582.582V2.133a.97.97,0,0,0,.97.97H3.685a.582.582,0,0,1,0,1.164Z"
                                                transform="translate(10.667 2.909)"
                                                fill="#ffab00"
                                            />
                                            <path
                                                id="Vector-3"
                                                data-name="Vector"
                                                d="M3.685,1.164H.582A.586.586,0,0,1,0,.582.586.586,0,0,1,.582,0h3.1a.586.586,0,0,1,.582.582A.586.586,0,0,1,3.685,1.164Z"
                                                transform="translate(5.624 9.503)"
                                                fill="#ffab00"
                                            />
                                            <path
                                                id="Vector-4"
                                                data-name="Vector"
                                                d="M6.788,1.164H.582A.586.586,0,0,1,0,.582.586.586,0,0,1,.582,0H6.788A.586.586,0,0,1,7.37.582.586.586,0,0,1,6.788,1.164Z"
                                                transform="translate(5.624 12.606)"
                                                fill="#ffab00"
                                            />
                                            <path
                                                id="Vector-5"
                                                data-name="Vector"
                                                d="M0,0H18.619V18.619H0Z"
                                                fill="none"
                                                opacity="0"
                                            />
                                            <path
                                                id="Vector-6"
                                                data-name="Vector"
                                                d="M0,0H18.619V18.619H0Z"
                                                fill="none"
                                                opacity="0"
                                            />
                                        </svg>
                                    </span>
                                    <span>Total Applied</span>
                                </div>
                                <span class="font-bold">{{
                                    items?.applicants.totalLoans ?? 0
                                }}</span>
                            </div>-->
                        </div>
                    </div>
                </div>

                <!-- Contents -->
                <div
                    class="flex flex-row justify-between w-full mt-[40px] space-x-[20px]"
                >
                    <!-- Left -->
                    <div class="flex flex-col w-1/2">
                        <div
                            class="flex flex-col w-full bg-white rounded-lg p-[20px] border-[2px] border-[#efefef]"
                        >
                            <h2
                                class="font-semibold text-[18px] text-black py-[20px]"
                            >
                                Applicants per region
                            </h2>
                            <!-- Map -->
                            <div
                                class="bg-gray-200 border-[2px] w-full h-[280px]"
                            >
                                <GMapMap
                                    :center="center"
                                    :zoom="2"
                                    :options="mapOptions"
                                    map-type-id="roadmap"
                                    class="map"
                                >
                                    <GMapMarker
                                        :key="index"
                                        :icon="`https://mindful-bobi-assets.s3.ca-central-1.amazonaws.com/markers/markers/${m.id}.png`"
                                        :position="m.position"
                                        :streetViewControl="false"
                                        :fullscreenControl="false"
                                        v-for="(m, index) in items.regions.data"
                                    >
                                    </GMapMarker>
                                </GMapMap>
                            </div>
                            <!--# end map -->
                            <!-- province table -->
                            <div class="flex flex-col w-full mt-[20px]">
                                <div
                                    class="grid grid-cols-5 gap-4 pb-[20px] font-medium text-[15px] text-[#a4adb8]"
                                >
                                    <span class="inline-flex">Province</span>
                                    <span
                                        class="justify-center items-center inline-flex space-x-1"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
                                            /></svg
                                        ><i>Assigned</i></span
                                    >
                                    <span
                                        class="justify-center items-center inline-flex space-x-1"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                            /></svg
                                        ><i>Assigned</i></span
                                    >
                                    <span
                                        class="justify-center items-center inline-flex space-x-1"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
                                            /></svg
                                        ><i>Disbursed</i></span
                                    >

                                    <span
                                        class="justify-center items-center inline-flex space-x-1"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                            /></svg
                                        ><i>Disbursed</i></span
                                    >
                                </div>
                                <div
                                    v-for="province in items.regions.data"
                                    :key="province.id"
                                    class="grid grid-cols-5 gap-4 pb-[20px] font-medium text-[15px] text-[#4D4F5C]"
                                >
                                    <p
                                        class="inline-flex space-x-[8px] items-center flex-1"
                                    >
                                        <span
                                            :class="[
                                                `inline-flex w-[12px] h-[12px] rounded-full`,
                                                province.id,
                                            ]"
                                        ></span>
                                        <span class="truncate">{{
                                            province.code
                                        }}</span>
                                    </p>
                                    <p class="text-center">
                                        {{ province.applicants }}
                                    </p>
                                    <p class="text-center">
                                        {{ province.amount.assigned }}
                                    </p>
                                    <p class="text-center">
                                        {{ province.amount.totalDisbursed }}
                                    </p>
                                    <p class="text-center">
                                        {{ province.amount.disbursed }}
                                    </p>
                                </div>
                                <div
                                    class="grid mt-[4px] pt-[10px] border-t-[2px] border-[#f3f3f5] grid-cols-5 gap-4 pb-[20px] font-medium text-[15px] text-[#4D4F5C]"
                                >
                                    <span></span>
                                    <span class="text-center">
                                        {{
                                            items.regions.total.applicants
                                        }}</span
                                    >
                                    <span class="text-center">
                                        {{ items.regions.total.assigned }}</span
                                    >
                                    <span class="text-center">
                                        {{
                                            items.regions.total.totalDisbursed
                                        }}</span
                                    >
                                    <span class="text-center">
                                        {{
                                            items.regions.total.disbursed
                                        }}</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div
                            class="flex flex-col w-full bg-white rounded-lg mt-[20px] p-[20px] border-[2px] border-[#efefef]"
                        >
                            <h2
                                class="font-semibold text-[18px] text-black border-b-[2px] pb-[10px] border-[#f3f3f5]"
                            >
                                Latest Disbursed Companies
                            </h2>
                            <div class="flex flex-col w-full mt-[20px]">
                                <div
                                    class="grid grid-cols-4 gap-6 pb-[20px] font-medium text-[15px] text-[#a4adb8]"
                                >
                                    <span
                                        class="inline-flex col-span-2 items-center space-x-2"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                            />
                                        </svg>
                                        <i>Name</i>
                                    </span>
                                    <span
                                        class="justify-end items-center inline-flex space-x-2"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                            />
                                        </svg>
                                        <i>Date</i></span
                                    >
                                    <span
                                        class="justify-end items-center inline-flex space-x-2"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                            />
                                        </svg>
                                        <i>Amount</i></span
                                    >
                                </div>
                                <div
                                    v-for="company in items.companies"
                                    :key="company.id"
                                    class="grid grid-cols-4 gap-6 pb-[20px] font-medium text-[15px] text-[#4D4F5C]"
                                >
                                    <p
                                        class="inline-flex space-x-[8px] items-center flex-1 col-span-2"
                                    >
                                        <span>{{ company.name }}</span>
                                    </p>
                                    <p class="text-right">
                                        {{ company.completed }}
                                    </p>
                                    <p class="text-right">
                                        {{ company.disbursed }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Right -->
                    <div class="flex flex-col w-1/2 space-y-[20px]">
                        <EloCard
                            v-for="elo in items.elos"
                            :key="elo.id"
                            :elo="elo"
                        />
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script setup>
import Layout from "@/Shared/Layout";
import EloCard from "@/Shared/ELoCard";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { BarChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import { onMounted, ref } from "vue";
import { startOfWeek, endOfWeek } from "date-fns";
import Loading from "@/Shared/Loading";

Chart.register(...registerables);
const items = ref({});
const isLoading = ref(true);
const mapRef = ref(null);
const props = defineProps({
    data: Object,
    currentDate: Array,
    selectedDate: Array,
});
const openedMarkerID = ref(null);
const selectedDate = ref([
    startOfWeek(new Date(props.selectedDate[0]), { weekStartsOn: 1 }),
    endOfWeek(new Date(props.selectedDate[1]), { weekStartsOn: 1 }),
]);

const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

onMounted(async () => {
    const value = props.currentDate;
    await fetchItem(value);
    isLoading.value = false;
});

const ticks = {
    padding: 6,
    color: "#bac1cc",
    font: {
        weight: "400",
        family: "Poppins",
        size: 12,
    },
};
const chartOptions = ref({
    responsive: true,
    layout: { padding: 0 },
    barThickness: 42,
    borderColor: "#efefef",
    hoverBackgroundColor: "#6bf8ff",
    interaction: {
        mode: "point",
    },
    scales: {
        x: {
            grid: {
                display: false,
            },
            ticks,
        },
        y: {
            grid: {
                display: true,
                borderWidth: 0,
                lineWidth: 1,
                offset: false,
                color: "#f3f3f3",
            },
            ticks,
        },
    },
    elements: {
        bar: {
            barThickness: 42,
            borderColor: "#efefef",
            color: "#fe0017",
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            boxWidth: 137,
            padding: 20,
            borderColor: "#efefef",
            borderWidth: 1,
            backgroundColor: "#ffffff",
            titleColor: "#000000",
            bodyColor: "#B1B7C3",
            titleFont: {
                font: {
                    size: 14,
                    weight: "medium",
                },
            },
            bodyFont: {
                font: {
                    size: 14,
                    weight: "regular",
                },
            },
            callbacks: {
                label: (ctx) => ctx.label,
                title: (ctx) => {
                    const context = ctx[0] || null;
                    const idx = context?.dataIndex;
                    const val = context?.dataset?.data[idx] ?? 0;
                    return `${val} Applications`;
                },
            },
        },
    },
    maintainAspectRatio: false,
});
const mapStyle = [
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#e9e9e9",
            },
            {
                lightness: 17,
            },
        ],
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                color: "#f5f5f5",
            },
            {
                lightness: 20,
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#ffffff",
            },
            {
                lightness: 17,
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#ffffff",
            },
            {
                lightness: 29,
            },
            {
                weight: 0.2,
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff",
            },
            {
                lightness: 18,
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff",
            },
            {
                lightness: 16,
            },
        ],
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#f5f5f5",
            },
            {
                lightness: 21,
            },
        ],
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
            {
                color: "#dedede",
            },
            {
                lightness: 21,
            },
        ],
    },
    {
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "on",
            },
            {
                color: "#ffffff",
            },
            {
                lightness: 16,
            },
        ],
    },
    {
        elementType: "labels.text.fill",
        stylers: [
            {
                saturation: 36,
            },
            {
                color: "#333333",
            },
            {
                lightness: 40,
            },
        ],
    },
    {
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
            {
                color: "#f2f2f2",
            },
            {
                lightness: 19,
            },
        ],
    },
    {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#fefefe",
            },
            {
                lightness: 20,
            },
        ],
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#fefefe",
            },
            {
                lightness: 17,
            },
            {
                weight: 1.2,
            },
        ],
    },
];
const center = { lat: 56.130367, lng: -106.346771 };
const mapOptions = {
    styles: mapStyle,
    zoomControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
};

const formatDate = (date) => {
    if (typeof date === "object") {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }
    return `${date}`;
};

const fetchItem = async (value) => {
    const d1 = value[0] ?? new Date();
    const d2 = value[1] ?? new Date();
    const date = `${formatDate(d1)} : ${formatDate(d2)}`;
    const { data } = await axios.post("/reports/filter", { date });
    items.value = data;
    handleChartOptions();
};

const handleChange = async (value) => {
    try {
        isLoading.value = true;
        await fetchItem(value);
        isLoading.value = false;
    } catch (e) {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: e.message,
        });
    } finally {
        isLoading.value = false;
    }
};

const handleChartOptions = () => {
    const len = items.value?.applicants?.chart?.labels.length;
    if (len <= 7) {
        chartOptions.value.barThickness = 60;
    }
    if (len > 7 && len <= 14) {
        chartOptions.value.barThickness = 30;
    }
    if (len > 14 && len <= 21) {
        chartOptions.value.barThickness = 20;
    }
    if (len > 21 && len <= 28) {
        chartOptions.value.barThickness = 10;
    }
    if (len > 21 && len <= 50) {
        chartOptions.value.barThickness = 5;
    }
    if (len > 50 && len <= 150) {
        chartOptions.value.barThickness = 2;
    }
    if (len > 150) {
        chartOptions.value.barThickness = 1;
    }
};
</script>
<style scoped>
.bc {
    background-color: #f9cb9c;
}

.ab {
    background-color: #f3cccb;
}

.sk {
    background-color: #cccccc;
}

.mb {
    background-color: #b6d7a8;
}

.on {
    background-color: #8e7cc3;
}

.qc {
    background-color: #6fa8dc;
}

.nb {
    background-color: #00daed;
}

.nl {
    background-color: #fbbc06;
}

.ns {
    background-color: #3c85c6;
}

.pe {
    background-color: #34a852;
}

.nt {
    background-color: #eb1f26;
}

.yt {
    background-color: #000000;
}

.map {
    position: relative;
    width: 100%;
    height: 280px;
}
</style>
